export default "__VITE_ASSET__Bz0D8jIM__"